export default "__VITE_ASSET__CiwYAFzC__"